import { useTranslation } from '../../../i18n/TranslationContext';

const valueKeys = [
  { titleKey: 'about.values.growth', descKey: 'about.values.growth_desc', number: '01' },
  { titleKey: 'about.values.creativity', descKey: 'about.values.creativity_desc', number: '02' },
  { titleKey: 'about.values.mindset', descKey: 'about.values.mindset_desc', number: '03' },
  { titleKey: 'about.values.integrity', descKey: 'about.values.integrity_desc', number: '04' },
  { titleKey: 'about.values.impact', descKey: 'about.values.impact_desc', number: '05' },
];

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-20 md:py-28 bg-secondary-50/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <span className="text-xs text-primary-500 font-medium uppercase tracking-widest mb-4 block">
          {t('about.heading')}
        </span>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 mb-24 md:mb-32">
          <div>
            <img src="/logo.png" alt="Dragonfruit" className="h-10 w-auto mb-6" />
            <h3 className="text-xl font-bold text-foreground-950 mb-5">
              {t('about.section_title')}
            </h3>
            <p className="text-sm text-foreground-700 leading-relaxed mb-5">
              {t('about.company_desc')}
            </p>
          </div>
          <div className="flex items-start lg:pt-4">
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('about.company_desc2')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 mb-24 md:mb-32">
          <div>
            <h3 className="text-5xl md:text-7xl font-heading text-primary-200 mb-6">
              {t('about.vision_title')}
            </h3>
            <p className="text-lg md:text-xl font-bold text-foreground-950 leading-snug mb-5">
              {t('about.vision_text')}
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('about.vision_text2')}
            </p>
          </div>
          <div>
            <h3 className="text-5xl md:text-7xl font-heading text-accent-300 mb-6">
              {t('about.mission_title')}
            </h3>
            <p className="text-lg md:text-xl font-bold text-foreground-950 leading-snug mb-5">
              {t('about.mission_text')}
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('about.mission_text2')}
            </p>
          </div>
        </div>

        <div id="creators">
          <h3 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            {t('about.values_title')}
          </h3>
          <p className="text-sm text-foreground-600 mb-12 md:mb-16 max-w-xl leading-relaxed">
            {t('about.values_subtitle')}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {valueKeys.map((v, i) => (
              <div
                key={i}
                className="bg-background-50 rounded-2xl border border-foreground-100/60 p-8 md:p-10 flex flex-col group hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
              >
                <span className="text-4xl font-heading text-primary-400 mb-6 group-hover:text-primary-500 transition-colors duration-300">
                  {v.number}
                </span>
                <h4 className="text-sm font-bold text-foreground-950 mb-2.5">
                  {t(v.titleKey)}
                </h4>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {t(v.descKey)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}